import { Locales } from '@griply/types';
import { useTranslation } from 'react-i18next';

export const useI18nLocale = () => {
  const { i18n } = useTranslation();
  return (i18n.resolvedLanguage as Locales) ?? Locales.EnUS;
};
